import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'theme';
import Tools from './Tools';
import LanguageSelection from './LanguageSelection';

const Wrapper = styled.nav`
    min-width: ${theme.componentMeasures.leftNavWidth};
    border-right: 1px solid rgb(229, 229, 229);

    @media (max-width: 1175px) {
        display: none;
    }
`;

const Title = styled.h2`
    border-bottom: 1px solid ${theme.colors.border_light_gray};
    font-family: ${theme.fonts.regular};
    height: ${theme.componentMeasures.searchBarHeight};
    margin: 0;
    padding: 10px 0 10px 25px;

    svg {
        margin: 0 10px 0 0;
        color: ${theme.colors.gray_dark};
    }
`;

export default function LeftNavigation() {
    return (
        <Wrapper>
            <Link to="/">
                <Title>
                    <FontAwesomeIcon icon={['far', 'chart-line']} />{' '}
                    Analysaattori
                </Title>
            </Link>
            <Tools />
            {/*FIXME: Uncomment when english translations ready
            <LanguageSelection />*/}
        </Wrapper>
    );
}
